export default function CTASection() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative py-24 md:py-32 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20soft%20pink%20magenta%20gradient%20waves%20flowing%20elegantly%20across%20a%20clean%20minimalist%20canvas%2C%20smooth%20organic%20curves%2C%20modern%20corporate%20design%2C%20light%20airy%20composition%20with%20subtle%20texture%2C%20professional%20abstract%20background%2C%20no%20text%2C%20warm%20neutral%20undertones&width=1920&height=800&seq=az-cta-bg&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-primary-500/90"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto px-4 md:px-6 text-center">
        <h2 className="font-heading text-3xl md:text-5xl font-bold text-background-50 leading-tight mb-5">
          Klaar voor een frisse start?
        </h2>
        <p className="text-background-50/85 text-base md:text-lg leading-relaxed mb-10 max-w-xl mx-auto">
          Heeft u schoonmaak nodig voor uw bedrijfspand, winkel of zorginstelling? 
          Vraag direct een vrijblijvende offerte aan. Wij reageren binnen 24 uur.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#contact"
            onClick={(e) => { e.preventDefault(); scrollTo('contact'); }}
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50 text-primary-600 text-base font-semibold whitespace-nowrap hover:bg-background-100 transition-all duration-200 cursor-pointer"
          >
            Offerte aanvragen
            <i className="ri-arrow-right-line"></i>
          </a>
          <a
            href="tel://+31641405833"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-background-50/10 text-background-50 text-base font-medium whitespace-nowrap border border-background-50/25 hover:bg-background-50/20 transition-all duration-200 cursor-pointer"
          >
            <i className="ri-phone-line"></i>
            Bel direct
          </a>
        </div>
      </div>
    </section>
  );
}